<template>
  <div class="container mt-2">
    <v-img
      class="content"
      max-width="80%"
      :src="require('@/assets/secreti.gif')"
    ></v-img>
  </div>
</template>

<script>
export default {
  name: "SecretI",
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
